/* eslint-disable newline-per-chained-call */
/* eslint-disable func-names */
import $ from 'jquery';

function handleChange( $el ) {
	const value = $el.val();
	// const kidsPrice = $( '.wcpa_free_kids input:checked' ).val();
	const priceData = JSON.parse( $el.find( 'option[data-price]:first' ).attr( 'data-price' ) );
	const customPrice = $el.closest( '.wcpa_row' ).next( '.wcpa_row' ).find( 'input:checked' ).val();
	const price = priceData.pricingType === 'custom' ? customPrice : priceData.value;
	const priceInt = parseInt( price, 10 );
	const totalInt = parseInt( value, 10 ) * parseFloat( price );

	// If price is 0 set to free.
	if ( priceInt === 0 ) {
		$el.closest( '.wcpa_row' ).find( '.magical_price' ).text( 'Free' );
	}

	// If price 0 and it's not free reset to original price.
	if ( value === '' && priceInt !== 0 ) {
		$el.closest( '.wcpa_row' ).find( '.magical_price' ).text( `$${parseFloat( price ).toFixed( 2 )}` );
		return;
	}

	// Update a normal price.
	if ( priceInt !== 0 ) {
		$el.closest( '.wcpa_row' ).find( '.magical_price' ).text( `$${parseFloat( totalInt ).toFixed( 2 )}` );
	}
}

function initalPrice() {
	$( '.wcpa_select_ticket' ).each( function () {
		const priceData = JSON.parse( $( this ).find( 'option[data-price]:first' ).attr( 'data-price' ) );
		const customPrice = $( this ).closest( '.wcpa_row' ).next( '.wcpa_row' ).find( 'input:checked' ).val();
		const initialValue = priceData.pricingType === 'custom' ? customPrice : priceData.value;
		const priceInt = parseFloat( initialValue );
		const price = priceInt !== 0 ? `$${priceInt.toFixed( 2 )}` : 'Free';
		$( `<span class="magical_price">${price}</span>` ).insertBefore( $( this ).parent() );
	} );
}

function initEvents() {
	$( '.wcpa_select_ticket' ).on( 'change', function () {
		handleChange( $( this ) );
	} );

	$( '.wcpa_weekends input, .wcpa_holidays input, .wcpa_groups input' ).on( 'change', function () {
		const $el = $( this ).closest( '.wcpa_row' ).prev( '.wcpa_row' ).find( '.wcpa_select_ticket' );
		handleChange( $el );
	} );
}

function init() {
	initalPrice();
	initEvents();
}

export default {
	init,
};
